import request from "@/utils/request";

// 获取菜单
export const getMenus = (params) => {
  return request({
    url: "/api/pub/menu/tree",
    method: "GET",
    params,
  });
};

// 发送手机验证码
export const postSendCode = (params) => {
  return request({
    url: "/api/pub/auth/login/sms/send",
    method: "POST",
    params,
  });
};

// 登录
export const postCodeLogin = (data) => {
  return request({
    url: "/api/pub/auth/login/sms",
    method: "POST",
    data,
  });
};

export const getInfo = () => {
  return request({
    url: "/api/pub/user/self",
    method: "GET",
  });
};

// 退出登录
export const postLogout = () => {
  return request({
    url: "/api/auth/logout",
    method: "POST",
  });
};

// 账号密码登录
export const postPasswordLogin = (data) => {
  return request({
    url: "/api/pub/auth/login/pwd",
    method: "POST",
    data,
  });
};

// 获取跳转链接
export const getJumpUrl = (params) => {
  return request({
    url: "/api/auth/code/gen",
    method: "GET",
    headers: { "X-TO": "1" },
    params,
  });
};

// 获取类别 /api/dictionary/data
export const getDictionaryItem = (params) => {
  return request({
    url: "/api/dictionary/data",
    method: "GET",
    params: { types: params },
  });
};
// 获取授权配置AI
export const getChatInfo = (params) => {
  return request({
    url: "/api/pub/ai/chat/info",
    method: "GET",
    params: params,
  });
};
